export default "data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAACwAQCdASoQAAsAAsBMJZwC7AEJAEwAAP6U1cpa3rHO8M6McI0GxGqibzmTEUe0tDjhBkrl30LJBHfGgcUYAA==";